export default {
  updateAll: (state, value) => (state.all = value),
  updateSingle: (state, value) => (state.single = value),
  updateOwners: (state, value) => (state.owners = value),
  updateAddressTypes: (state, value) => (state.addressTypes = value),
  updateMetaDataColumns: (state, value) => (state.metaDataColumns = value),
  updateMetaDataFields: (state, payload) => (state.metaDataFields = payload)
}
